import { ref, computed } from 'vue';
import { useSendTicket } from './useSendTicket';

export function useEnviarEntradas(pedido) {
    const { email, nombre, apellidos, isValid, loading, error, send, reset } = useSendTicket();

    const entradas = computed(() => pedido.value?.entradas || []);
    const seleccionadas = ref([]);

    const isSelected = e => seleccionadas.value.some(s => s.id === e.id);
    const isAllSelected = computed(() => entradas.value.length > 0 && seleccionadas.value.length === entradas.value.length);
    const isSomeSelected = computed(() => seleccionadas.value.length > 0 && seleccionadas.value.length < entradas.value.length);

    const toggleEntrada = e => {
        if (isSelected(e)) seleccionadas.value = seleccionadas.value.filter(s => s.id !== e.id);
        else seleccionadas.value = [...seleccionadas.value, e];
    };

    const toggleAll = () => {
        if (isAllSelected.value) seleccionadas.value = [];
        else seleccionadas.value = [...entradas.value];
    };

    const canSend = computed(() => isValid.value && seleccionadas.value.length > 0);

    const enviar = async() => {
        const qrCodes = seleccionadas.value.map(e => e.qr_code).filter(Boolean);
        const ok = await send({ pedidoId: pedido.value?.id, qrCodes });
        if (ok) { seleccionadas.value = []; reset(); }
        return ok;
    };

    return { email, nombre, apellidos, isValid, loading, error, entradas, seleccionadas, isSelected, isAllSelected, isSomeSelected, toggleEntrada, toggleAll, canSend, enviar };
}
